import {config} from '../config';
import { handleResponse, buildQuery, addTenant, authHeader } from '../helpers';

export const surveyService = {
    getSurvey,
    saveAnswer,
    getSurveyAnalytics,
    getRouterJLS,
    getRouterSettlements,
    getAllSurveyData,
    updateSurveyData,
    setParentSurvey,
    getSurveyDataByStatus,
    getSurveyData,
    getDailyDemandPerHour,
    getSurveyAnsweredCount,
    getUnverifiedSurveysCount,
    getCounties,
    getJLS,
    getSettlements,
    getRouterJLSWithStatus,
    getClosestPoints,
    getSurveyAnalysis,
    getLogging,
    getUserActivity,
    getSettlementTransactionActivity,
    getJLSTransactionActivity,
    updateGeom
};


// Used to get question answers by their key names reuse this when you need  answers by key name
async function getSurveyAnalytics(analytics_name,survey_id,municipalities) {
    const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...authHeader() }, 
    };
    return fetch(`${config.apiUrl}/transactions?key=${analytics_name}&${searchForSurveyId(survey_id,municipalities)}`, requestOptions).then(handleResponse)
}

//Used to get analysis by their url, reuse this when needing analysis
async function getSurveyAnalysis(analysis_url,municipalities) {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/analysis/${analysis_url}?${mapArrayToQueryString('idrouter', municipalities)}`, requestOptions).then(handleResponse)
}


function getSurvey(id) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/survey?id=${id}&t=${new Date().toISOString()}`, requestOptions).then(handleResponse);
}

async function saveAnswer(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //credentials: 'include',
        body: JSON.stringify(data)
    };
    return fetch(`${config.apiUrl}/transactions`, requestOptions).then(handleResponse)
}



function searchForSurveyId(survey_id,municipalities){
    if(survey_id && municipalities){
        return(`idcontrols=${survey_id}&jls=${municipalities}`)
    }
    else if(survey_id &&!municipalities)
    {
        return(`idcontrols=${survey_id}`)
    }
    else if(!survey_id && municipalities){
        return(`idrouter[0]=${municipalities}`)
    }
    else {
        return ``
    }
}


function mapArrayToQueryString(key, arr) {
    if(!arr || (arr && (!arr.length || arr.length && arr.every(v => !v)))) {
        return ``
    }
    return arr.map(a => `${key}[]=${a}`).join('&')
}

async function getSurveyAnsweredCount(surveyNumber) {
    const requestOptions = {
        method: 'GET', 

        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/count/number-of-answers?idcontrols=${surveyNumber}`, requestOptions).then(handleResponse)
}



async function getUnverifiedSurveysCount(transaction_url)
{
    const requestOptions = {
        method: 'GET', 

        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
        return fetch(`${config.apiUrl}/transactions/${transaction_url}`, requestOptions).then(handleResponse)
    
    
    
}

async function getAllSurveyData() {
    const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //headers: authHeader() 
    };
    return fetch(`${config.apiUrl}/transactions`, requestOptions).then(handleResponse)
}

async function getSurveyDataByStatus(status,idcontrols) {
    const requestOptions = {
        method: 'GET', 
        headers: { ...addTenant() }
        //headers: authHeader() 
    };
    return fetch(`${config.apiUrl}/transactions/status?status=${status}&idcontrols=${idcontrols}`, requestOptions).then(handleResponse)
}

async function updateSurveyData(data) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //credentials: 'include',
        body: JSON.stringify(data)
    };
    return fetch(`${config.apiUrl}/transactions`, requestOptions).then(handleResponse)
}

async function setParentSurvey(data) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //credentials: 'include',
        body: JSON.stringify(data)
    };
    return fetch(`${config.apiUrl}/transactions/closest-point`, requestOptions).then(handleResponse)
}


async function getSurveyData() {
    const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //headers: authHeader() 
    };
    return fetch(`${config.apiUrl}/transactions/verification`, requestOptions).then(handleResponse)
}

async function getDailyDemandPerHour(dayNum, municipalities) {
    const requestOptions = {
        method: 'GET', 

        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/analysis/get-demand-per-hour-by-day?day=${dayNum}&${mapArrayToQueryString('idrouter', municipalities)}`, requestOptions).then(handleResponse)
}



async function getRouterJLS() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/router/jls`, requestOptions).then(handleResponse)
}

async function getRouterJLSWithStatus() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/router/jls-with-status`, requestOptions).then(handleResponse)
}

async function getRouterSettlements() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/router/settlements`, requestOptions).then(handleResponse)
}

//functions for surveys
async function getCounties() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/counties`, requestOptions).then(handleResponse)
}

async function getJLS(county) {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/jls?id=${county}`, requestOptions).then(handleResponse)
}


async function getSettlements(JLS) {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/settlements?id=${JLS}`, requestOptions).then(handleResponse)
}


async function getClosestPoints(longitude,latitude) {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/transactions/closest-point?latitude=${latitude}&longitude=${longitude}`, requestOptions).then(handleResponse)
}


async function getLogging() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/logging`, requestOptions).then(handleResponse)
}

async function getUserActivity() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
    return fetch(`${config.apiUrl}/user-activity`, requestOptions).then(handleResponse)
}




async function getJLSTransactionActivity() {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };
        return fetch(`${config.apiUrl}/transactions/jls-transaction-activity`, requestOptions).then(handleResponse)
}

async function getSettlementTransactionActivity(jls_pick) {
    const requestOptions = {
        method: 'GET', 
        //headers: { ...addTenant() }
        headers: { 'Content-Type': 'application/json', ...authHeader() },
    };    
        return fetch(`${config.apiUrl}/transactions/settlement-transaction-activity?jls_pick=${jls_pick}`, requestOptions).then(handleResponse)   
}


async function updateGeom(data) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        //credentials: 'include',
        body: JSON.stringify(data)
    };
    return fetch(`${config.apiUrl}/transactions/update-geom`, requestOptions).then(handleResponse)
}